import { useAxios } from "../utils/hooks";

export const GuestUserApi = () => {

    const AxiosInstance = useAxios();
    const postUploadExcelForGuestUser = async (formData: any) => {

        try {
            const res: any = await AxiosInstance.current?.post(`/route/GuestUser/postUploadExcelForGuestUser`, formData);
            return res;
        } catch (error) {
            console.error(error);
        }
    }
    const getGuestUser = async () => {

        try {
            const res: any = await AxiosInstance.current?.get(`/route/GuestUser/getGuestUser`);
            return res;
        } catch (error) {
            console.error(error);
        }
    }
    const uploadAppoinment = async (formData: any, userId: string) => {
        try {
            const res: any = await AxiosInstance.current?.post(
                `/route/GuestUser/uploadAppoinment?userId=${userId}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return res;
        } catch (error) {
            console.error(error);
        }
    };
    const updateAppoinmentStatus = async (userId: any, type: any) => {

        try {
            const res: any = await AxiosInstance.current?.post(`/route/GuestUser/updateAppoinmentStatus?userId=${userId}&type=${type}`);
            return res;
        } catch (error) {
            console.error(error);
        }
    }
    const getAppoinmentForm = async () => {
        try {
            const res = await AxiosInstance.current?.get(`/route/GuestUser/getAppoinmentForm`);
            return res?.data?.data; // return the URL directly
        } catch (error) {
            console.error("Error fetching appointment form:", error);
            return null;
        }
    };
    const getInterViewForm = async () => {
        try {
            const res = await AxiosInstance.current?.get(`/route/GuestUser/getInterViewForm`);
            return res?.data?.data; // return the URL directly
        } catch (error) {
            console.error("Error fetching appointment form:", error);
            return null;
        }
    };
    const sendemailAndWhatsapp = async (data: any) => {
        try {
            const res = await AxiosInstance.current?.post(`/route/GuestUser/sendemailAndWhatsapp`, data);
            return res; // return the URL directly
        } catch (error) {
            console.error("Error fetching appointment form:", error);
            return null;
        }
    };
    const postUploadExcelForInterview = async (formData: any) => {

        try {
            const res: any = await AxiosInstance.current?.post(`/route/GuestUser/postUploadExcelForInterview`, formData);
            return res;
        } catch (error) {
            console.error(error);
        }
    }
    const getInterviewUser = async () => {

        try {
            const res: any = await AxiosInstance.current?.get(`/route/GuestUser/getInterviewUser`);
            return res;
        } catch (error) {
            console.error(error);
        }
    }
    const uploadInterview = async (formData: any, userId: string) => {
        try {
            const res: any = await AxiosInstance.current?.post(
                `/route/GuestUser/uploadInterview?userId=${userId}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return res;
        } catch (error) {
            console.error(error);
        }
    };


    return {
        postUploadExcelForGuestUser, getGuestUser, uploadAppoinment, updateAppoinmentStatus, getAppoinmentForm,
        sendemailAndWhatsapp, getInterViewForm, getInterviewUser, postUploadExcelForInterview, uploadInterview
    }
}